import { getAxiosClient } from '../../client';
import { makeApiRequest } from '../../makeApiRequest';
import type { ApiResponse } from '../../responses';
import type { IOrganizationsService } from './IOrganizationsService';
import { OrganizationsEndpoints } from './organizationsEndpoints';
import {
    toAccountingStartResult,
    toOrganization,
} from './organizationsMapping';
import type { AccountingStartRequest } from './requests';
import type {
    AccountingStartResponse,
    AccountingStartWire,
    OrganizationResponse,
    OrganizationWire,
} from './responses';

type OrganizationsServiceOptions = {
    baseUrl: string;
};

export class OrganizationsService implements IOrganizationsService {
    private readonly baseUrl: string;

    constructor({ baseUrl }: OrganizationsServiceOptions) {
        this.baseUrl = baseUrl;
    }

    public async getMe(): Promise<ApiResponse<OrganizationResponse>> {
        const result = await makeApiRequest<OrganizationWire>(
            getAxiosClient({ baseURL: this.baseUrl }).get(
                OrganizationsEndpoints.me(),
            ),
        );
        if (!result.success) {
            return result;
        }
        return { success: true, response: toOrganization(result.response) };
    }

    public async finishOnboarding(): Promise<
        ApiResponse<OrganizationResponse>
    > {
        const result = await makeApiRequest<OrganizationWire>(
            getAxiosClient({ baseURL: this.baseUrl }).post(
                OrganizationsEndpoints.finishOnboarding(),
            ),
        );
        if (!result.success) {
            return result;
        }
        return { success: true, response: toOrganization(result.response) };
    }

    public async accountingStart(
        body: AccountingStartRequest,
    ): Promise<ApiResponse<AccountingStartResponse>> {
        const result = await makeApiRequest<AccountingStartWire>(
            getAxiosClient({ baseURL: this.baseUrl }).post(
                OrganizationsEndpoints.accountingStart(),
                { year: body.year },
            ),
        );
        if (!result.success) {
            return result;
        }
        return {
            success: true,
            response: toAccountingStartResult(result.response),
        };
    }
}
